// extracted by extract-css-chunks-webpack-plugin
module.exports = {"page_list":"page_list-32dJk_6E clearfix","current":"current-3ChFsBmu"};